import { render } from "./index.vue?vue&type=template&id=66c64796&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=66c64796&lang=scss&scoped=true"

import exportComponent from "/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66c64796"],['__file',"src/components/DropdownButton/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "66c64796"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('66c64796', __exports__)) {
    console.log('reload')
    api.reload('66c64796', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=66c64796&scoped=true", () => {
    console.log('re-render')
    api.rerender('66c64796', render)
  })

}


export default __exports__